import { Route } from 'react-router-dom'
import { AlbumShellLayout } from '@/features/album/layouts/AlbumShellLayout'
import { SearchResultsScreen } from './screens/SearchResults'

/**
 * Global search route — mounted inside album/routes.tsx's `AlbumDesignRoot`,
 * reusing the same app shell as /albums, /galleries, /connections, etc.
 * Supersedes the legacy `/search` page (see RootRouter.tsx).
 *
 * /search?key=…
 */
export const searchRouteElements = (
  <Route path='search' element={<AlbumShellLayout />}>
    <Route index element={<SearchResultsScreen />} />
  </Route>
)
